// src/utils/formatCurrency.js

/**
 * Formatea un valor como moneda en formato MXN.
 * @param {number|string} value - El valor a formatear.
 * @param {boolean} [divideBy100=true] - Indica si el valor debe dividirse por 100.
 * @returns {string} - El valor formateado como moneda.
 */
const formatCurrency = (value, divideBy100 = false) => { // Cambiar divideBy100 a false por defecto
  console.log('Valor recibido en formatCurrency:', value, 'Divide por 100:', divideBy100); // Depuración
  // Si no hay valor, mostramos $0.00
  if (value === null || value === undefined || value === '') return '$0.00';

  // Convertir a cadena si no lo es
  let stringValue = typeof value === 'string' ? value : value.toString();

  // Eliminamos caracteres no numéricos excepto el punto
  const cleanedValue = stringValue.replace(/[^\d.]/g, '');

  // Convertir a número
  let numberValue = parseFloat(cleanedValue);

  // Si se requiere, dividir por 100 para convertir centavos a pesos
  if (divideBy100) {
    numberValue = numberValue / 100;
  }

  // Validar si es un número
  if (isNaN(numberValue)) return '$0.00';

  // Formatear como moneda
  const formatted = numberValue.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
  });

  console.log('Valor formateado en formatCurrency:', formatted); // Depuración

  return formatted;
};

export default formatCurrency;
